import { useEffect, useState, useCallback } from 'react';
import { Pane, Tablist, Tab, Button, FolderNewIcon, TrashIcon, EditIcon, Spinner, Heading, FolderOpenIcon } from 'evergreen-ui';
import subsectionServices from '../services/subsectionServices';
import SubsectionForm from './SubsectionForm';
import { useRole } from '../contexts/RoleContext';

const SubsectionsList = ({ sectionId, userRole = 'educatore', selectedSubsectionId = null, onSelectSubsection = () => {} }) => {
    const { effectiveIsDirector: isDirector } = useRole();
    const [subsections, setSubsections] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFormShown, setIsFormShown] = useState(false);
    const [editing, setEditing] = useState(null);
    const [localSelected, setLocalSelected] = useState(selectedSubsectionId);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const data = await subsectionServices.fetchSubsections(sectionId);
            setSubsections(data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [sectionId]);

    useEffect(() => {
        if (sectionId) load();
    }, [sectionId, load]);

    useEffect(() => {
        setLocalSelected(selectedSubsectionId);
    }, [selectedSubsectionId]);

    const handleAdd = () => {
        setEditing(null);
        setIsFormShown(true);
    };

    const handleEdit = (sub) => {
        setEditing(sub);
        setIsFormShown(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Confermi di voler eliminare la sottocartella?')) return;
        try {
            await subsectionServices.removeSubsection(id);
            await load();
        } catch (e) {
            console.error(e);
        }
    };

    const handleSave = async (payload) => {
        try {
            if (editing && editing.id) {
                await subsectionServices.updateSubsection(editing.id, payload);
            } else {
                await subsectionServices.addSubsection(payload);
            }
            setIsFormShown(false);
            setEditing(null);
            await load();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Pane>
            <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={8}>
                <Heading size={500}>Sottocartelle</Heading>
            </Pane>

            {loading ? <Spinner /> : (
                <Pane display="flex" alignItems="center" marginBottom={8}>
                    <Pane flexGrow={1}>
                        <Tablist>
                            {subsections.filter(sub => userRole !== 'educatore' || sub.is_visible_to_educators).map(sub => (
                                <Tab
                                    key={sub.id}
                                    isSelected={localSelected === sub.id}
                                    onSelect={() => {
                                        if (localSelected === sub.id) {
                                            setLocalSelected(null);
                                            onSelectSubsection(null);
                                        } else {
                                            setLocalSelected(sub.id);
                                            onSelectSubsection(sub.id);
                                        }
                                    }}
                                >
                                    <FolderOpenIcon marginRight={6} />
                                    {sub.name}{(userRole !== 'educatore' && Number(sub.is_visible_to_educators) === 1) ? ' (e)' : null}
                                </Tab>
                            ))}
                        </Tablist>
                    </Pane>

                    <Pane display="flex" alignItems="center" gap={8} marginLeft={8}>
                        {isDirector && (
                            <>
                                <Button onClick={handleAdd} marginRight={8}><FolderNewIcon /></Button>
                                <Button onClick={() => editing ? setIsFormShown(true) : handleEdit(subsections.find(s => s.id === localSelected))} marginRight={8} disabled={!localSelected}><EditIcon /></Button>
                                <Button onClick={() => handleDelete(localSelected)} intent="danger" disabled={!localSelected}><TrashIcon /></Button>
                            </>
                        )}
                    </Pane>
                </Pane>
            )}

            <SubsectionForm isShown={isFormShown} onClose={() => setIsFormShown(false)} onSave={handleSave} initial={editing || {}} sectionId={sectionId} />
        </Pane>
    );
};

export default SubsectionsList;
